export const VEHICLE_STATUS_STYLES = {
  available: "bg-green-500/15 text-green-400 border-green-500/30",
  pending: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30",
  sold: "bg-red-500/15 text-red-400 border-red-500/30",
  wholesale: "bg-purple-500/15 text-purple-400 border-purple-500/30",
  hold: "bg-orange-500/15 text-orange-400 border-orange-500/30",
  draft: "bg-white/10 text-white/60 border-white/20",
};

export function vehicleStatusLabel(status) {
  if (!status) return "UNKNOWN";
  return String(status).replace(/_/g, " ").toUpperCase();
}

export function vehicleStatusClass(status) {
  return VEHICLE_STATUS_STYLES[status] || "bg-white/10 text-white/70 border-white/20";
}
